import anime from 'animejs';
import is from 'is_js';
import _ from 'lodash';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { createUseStyles } from 'react-jss';
import { useNavigate } from 'react-router-dom';
import { usePlatformAPI } from '../../apis/platform-api';
import { useQRCodeAPI } from '../../apis/qrcode-api';
import { useInterval } from '../../hooks/use-interval';
import { useStorage } from '../../hooks/use-storage';
import { preloadPublicImages } from '../../utils/manager/image-manager';
import { EmptyQRCodeFirstScreen } from './empty-qrcode-first-screen';
import { EmptyQRCodeSecondScreen } from './empty-qrcode-second-screen';

const interval = 2000;

function EmptyQRCodeScreen({ id, batch }) {
  const { loadPlatformSupportFromRemote } = usePlatformAPI();
  const { loadQRCodeFromRemote } = useQRCodeAPI();
  const { showingModal } = useStorage();
  const [data, setData] = useState();
  const [countdownEnabled, setCountdownEnabled] = useState(true);
  const navigate = useNavigate();
  const classes = useStyles();
  const containerRef = useRef();
  const countdownRef = useRef(20 * 60 * 60 * 1000);

  useInterval(update, 2000, countdownEnabled);

  useEffect(() => {
    loadData();
  }, []);

  useLayoutEffect(() => {
    anime({
      targets: containerRef.current,
      opacity: showingModal ? 0.2 : 1,
      duration: showingModal ? 400 : 200,
      easing: 'easeInQuad',
    });
  }, [showingModal]);

  async function update() {
    const left = countdownRef.current - interval;
    if (left < 0) {
      setCountdownEnabled(false);
      return;
    }

    countdownRef.current = left;

    const result = await loadQRCodeFromRemote(id);
    const rQRCode = result.data;

    if (rQRCode?.spot?.id != null) {
      setCountdownEnabled(false);
      navigate(0);
    }
  }

  async function loadData() {
    preloadPublicImages();

    const response = await loadPlatformSupportFromRemote();
    setData(response.data);
  }

  const onAppDownloadClick = async (platform) => {
    console.log(`onAppDownloadClick: ${platform}`);

    if (platform == null) {
      if (is.ios() || is.mac()) {
        open(data?.app_store?.url);
      } else if (!is.android()) {
        share(data?.google_play?.url);
      } else {
        open(data?.google_play?.url);
      }
    } else if (platform === 'ios') {
      if (is.ios()) {
        open(data?.app_store?.url);
      } else {
        share(data?.app_store?.url);
      }
    } else if (is.android()) {
      open(data?.google_play?.url);
    } else {
      share(data?.google_play?.url);
    }
  };

  async function share(url) {
    if (url == null) return;
    let result = false;

    const sharingData = { url };

    if (
      // eslint-disable-next-line no-undef
      (_.isFunction(navigator.canShare) && navigator.canShare(sharingData)) ||
      // eslint-disable-next-line no-undef
      navigator.share
    ) {
      try {
        // eslint-disable-next-line no-undef
        await navigator.share(sharingData);

        result = true;
      } catch (error) {
        if (error.toString().includes('AbortError')) {
          result = true;
        } else {
          console.error(error);
          result = false;
        }
      }
    }

    if (result === false) {
      open(url);
    }
  }

  function open(url) {
    // eslint-disable-next-line no-undef
    window.location.href = url;
  }

  return (
    <div ref={containerRef} className={classes.container}>
      <EmptyQRCodeFirstScreen
        batch={batch}
        onAppDownloadClick={onAppDownloadClick}
      />
      <EmptyQRCodeSecondScreen onAppDownloadClick={onAppDownloadClick} />
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    // '&::-webkit-scrollbar': {
    //   display: 'none',
    //   width: 0,
    //   height: 0,
    // },
  },
});

export { EmptyQRCodeScreen };
